import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { TextField } from '@material-ui/core';
import NumberFormat, { NumberFormatValues } from 'react-number-format';


interface NumberFormatCustomProps {
    inputRef: (instance: NumberFormat | null) => void;
    onChange: (event: { target: { value: string } }) => void;
}

function NumberFormatCustom(props: NumberFormatCustomProps) {
    const { inputRef, onChange, ...other } = props;

    const onValueChange = React.useCallback((values: NumberFormatValues) => {
        onChange({
            target: {
                value: values.value,
            },
        })
    }, [onChange]);

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={onValueChange}
            decimalScale={0}
            isNumericString
        />
    );
}

const NumberTextField: React.FunctionComponent<FieldRenderProps<any, any>> = ({
    input: { name, onChange, value, ...restInput },
    meta,
    ...rest
}) => {

    const showError = meta.touched && (meta.error || (!!meta.submitError && !meta.dirtySinceLastSubmit)) && !meta.submitting;

    const onChangeFunc = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event);
    }, [onChange]);

    return <TextField
        {...rest}
        error={showError}
        helperText={showError ? meta.error || meta.submitError : undefined}
        inputProps={restInput}
        name={name}
        value={value}
        onChange={onChangeFunc}
        InputProps={{
            inputComponent: NumberFormatCustom as any,
        }}
        autoComplete="off"
    />
};

export default NumberTextField;